import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { SnackService } from "../../../services/snack.service";
import { Testbed } from "../../../model/testbed";
import { Contract } from "../../../model/contract";
import { ContractsService } from "../../../services/contracts.service";
import { Storage } from "../../../model/storage";
import { Company } from "../../../model/company";
import { TestbedsService } from "../../../services/testbeds.service";
import { CompaniesService } from "../../../services/companies.service";
import { Constants } from "../../../utils/constants";
import { AuthService } from "../../../services/auth.service";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'aw-testbed-form',
  templateUrl: './testbed-form.component.html',
  styleUrls: ['./testbed-form.component.scss']
})
export class TestbedFormComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Output() testbedEmitter: EventEmitter<Testbed> = new EventEmitter<Testbed>();
  @Input() embeddedLayout = false;
  @Input() creatingFromContract = false;

  testbedForm: UntypedFormGroup;
  saving = false;
  loadingCompanies = false;
  amICustomer = false;
  generalError?: ApiResponse;
  roles = Constants.roles;
  entities = Constants.entities;

  loggedUser: any;
  companies: Company[] = [];
  contracts: Contract[] = [];
  storages: Storage[] = [];

  companyValidatorsForUserRole: ValidatorFn[] = [];
  isEditing = false;

  constructor(
    private authService: AuthService,
    private companiesService: CompaniesService,
    private testbedsService: TestbedsService,
    private contractsService: ContractsService,
    private snackService: SnackService,
    public dialog: MatDialog
  ) {


    this.testbedForm = new UntypedFormGroup(
      {
        identifier: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        address: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        company: new UntypedFormControl(
          null,
          this.companyValidatorsForUserRole
        ),
      }
    );
  }

  _testbed = new Testbed();


  @Input() set testbed(value: Testbed) {
    if (value) {
      this._testbed = merge(new Testbed(), value);
      this.isEditing = !!this._testbed.id;
      this.testbedForm.patchValue(this._testbed);
      if (this.isEditing) {
        this.testbedForm.controls.company.disable();
      }
    }
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();

    this.amICustomer = this.loggedUser.role === this.roles.customer;

    if (!this.amICustomer) {
      this.companyValidatorsForUserRole.push(Validators.required);
    }


    this.loadingCompanies = true;

    if (!this.isEditing) {
      if (!this.amICustomer) {
        this.companiesService
          .getAllCompanies()
          .subscribe(companies => {
            this.companies = companies;
            this.loadingCompanies = false;
          });
      }

      if (this.amICustomer) {

        this.companies = (this.loggedUser.company) ? [this.loggedUser.company] : [];
        this.testbedForm.controls.company.setValue(this.loggedUser.company);
        this.loadingCompanies = false;

      }


    } else {
      this.companies = (!!this._testbed?.company) ? [this._testbed.company] : [];
      this.loadingCompanies = false;
    }
  }

  saveTestbed(): void {
    this.saving = true;

    const newTestbed = merge(new Testbed(), this._testbed, this.testbedForm.value);

    this.generalError = undefined;

    if (this._testbed.id) {
      delete newTestbed.contracts;
      delete newTestbed.currentContract;
      delete newTestbed.storage;
      delete newTestbed.company;
      this.testbedsService.updateTestbed(newTestbed)
        .subscribe(
          () => {
            this.saving = false;
            this._testbed = newTestbed;
            this.snackService.success('Testbed updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {

      if (this.amICustomer) {
        newTestbed.company = this.loggedUser.company;
      }
      this.testbedsService.createTestbed(newTestbed)
        .subscribe(
          createdTestbed => {
            this.saving = false;
            this.testbedEmitter.emit(createdTestbed);
            this._testbed = createdTestbed;
            this.snackService.success('Testbed created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

}
